// ChatWithImageUpload.jsx
import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import allData from './data.json';
const fetchURL = "https://api-fetch.mediadirhub.com/ads-api";

const preloader = function(show) {
  if(show) {
    document.querySelector("#preloader").classList.remove("hidden");
  }
  else {
    document.querySelector("#preloader").classList.add("hidden");
  }

}


const handlebarsJS = async function(html, text, chatId) {
    let response = await fetch(fetchURL, {
        method: 'POST',
       
        body: JSON.stringify({
          method:"handlebarsJS",
          messages:[
            {
                "role": "user",
                "content": [
                  {
                    "type": "text",
                    "text": `
                    Convert the following HTML into a Handlebars ad template.
  
                    - Replace all text, image URLs, and inline colors with Handlebars variables like {{headline}}, {{colors.background}}, etc.
                    - Use only inline CSS — do not use <style> tags.
                    - Return the result in JSON format with two keys:
                    - "html": containing the Handlebars HTML template as a string (escaped properly)
                    - "json": containing the sample data object (not inside a <script> tag)
                    - Do not include any markdown or explanations — only return valid JSON.
  
                    Here's the HTML to convert:
  
  
                    ${html.split("<body>").pop().split("</body>")[0]}
                    `
                  }
                ]
              }
          ]
        })
      });
      
      
    response = await response.json();
   const finalResponse = JSON.parse(response.choices[0].message.content);

    const topHtml = `
    ${html.split("<body>")[0]}<body>
    <script src="https://cdn.jsdelivr.net/npm/handlebars@latest/dist/handlebars.js"></script>
    ${finalResponse.html}
    <script>
    const docEle = document.querySelectorAll("div")[0];
    var template = Handlebars.compile(docEle.innerHTML);
  // execute the compiled template and print the output to the console

  
  const dbID = "raviJSON";

    if(dbID === "raviJSON") {
      docEle.innerHTML = template(${JSON.stringify(finalResponse.json)})
    }
    else {
      fetch("https://api-logs-app-default-rtdb.firebaseio.com/adsdb/raviEMAIL/raviCHAT/"+dbID+".json").then(function(a){
        a.json().then(function(ab){
          docEle.innerHTML = template(JSON.parse(ab.response))
        })
      })
    }
  </script>
    </body>
    ${html.split("</body>").pop()}
    `;
    const responseId = await saveAdsHTML(topHtml.replace(/\\n/g, ''), finalResponse.json);
    const postJSON = {
        text:text,
        id:responseId.name,
       
        data:JSON.stringify(finalResponse.json),
        response:JSON.stringify(finalResponse.json)
    }
    const responseMe = await fetchDB(chatId, "POST", postJSON);
    postJSON["dbID"] = responseMe.name;
    const nextJson = JSON.parse(JSON.stringify(postJSON));
    nextJson.data = JSON.parse(nextJson.data);
    nextJson.response = JSON.parse(nextJson.response);
    return {
        id:chatId,
        data:[nextJson]
    };

}
const createHTML = async function(text, image, chatId) {
    let response = await fetch(fetchURL, {
        method: 'POST',
        body: JSON.stringify({
          "method":"createHTML",
          "text":text,
          "image":image
        })
    });
    response = await response.json();
    return await handlebarsJS(response.choices[0].message.content, text, chatId);
}

const ShowPopup = function({callback, close}) {
    const [text, setText] = useState('');
    const [image, setImage] = useState();
    const uploadImage = function(e) {
        const file = e.currentTarget.files[0];
     
      //const file = e.target.files[0];
        const reader = new FileReader();

    reader.onload = function () {
      const base64 = reader.result.split(',')[1]; // Remove prefix if needed
      console.log('Base64 string:', reader.result);
      setImage(reader.result);
    };

    reader.readAsDataURL(file); // Converts to base64
    }
    const sendChat = function(e) {
        preloader(true);
        createHTML(text, image, Date.now()).then(function(a){
            console.log(a);
            callback(a);
            preloader();
        })
    }
    return  <div class="fixed inset-0 bg-black bg-opacity-40 flex items-end justify-center z-50 p-4">
    <div class="w-full max-w-2xl bg-white rounded-2xl shadow-xl p-4 space-y-3 relative">
      
      <button 
        class="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-xl font-bold"
        onClick={close}
        aria-label="Close"
      >
        &times;
      </button>
  
      <textarea
        class="w-full h-24 p-3 border border-gray-300 rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Write your prompt..."
        onInput={function(e){
          setText(e.currentTarget.value);
        }}
      ></textarea>
  
      <div class="flex items-center justify-between gap-4 flex-wrap">
        <label for="chat-image-upload" class="flex items-center gap-2 text-gray-600 cursor-pointer hover:text-blue-600">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M12 4v16m8-8H4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="text-sm">Upload Your Own</span>
        </label>
        <input id="chat-image-upload" type="file" class="hidden" accept="image/*" onChange={uploadImage} />
        
       
        
        <button onClick={sendChat} class="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-md text-sm font-medium">
          Send
        </button>
      </div>
    </div>
  </div>
  
  
    
}
const JoinEmail = function({joinEmail}) {
    return <div className="bg-gray-100 flex items-center justify-center min-h-screen"><div class="max-w-md w-full bg-white p-6 rounded-2xl shadow-lg">
    <h2 class="text-2xl font-bold mb-4 text-center">Join with Your Email</h2>
    <p class="text-gray-600 mb-6 text-center hidden">Get updates right to your inbox.</p>
    <div class="flex flex-col sm:flex-row gap-3">
      <input id="email"
        type="email"
        placeholder="Enter your email"
        class="flex-1 px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
        required
      />
      <button
        type="submit"
        class="px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition"
        onClick={() => joinEmail(document.querySelector("#email").value)}>
        Join
      </button>
    </div>
  </div>
  
  </div>
  
}

const saveAdsHTML = async function(html, data) {
    const response = await fetch(`https://api-logs-app-default-rtdb.firebaseio.com/adsdb-html.json`, {
        method:"POST",
        headers:{
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body:JSON.stringify({
            html:html,
            data:data
        })
    });
    return await response.json();
}

const fetchDB = async function(chatId, method, postJSON) {
    let headers = null;
    let body = null;
    if(!method) {
        method = "GET";
        headers= {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    }
    if(postJSON) {
        body = JSON.stringify(postJSON)
    }
    const response = await fetch(`https://api-logs-app-default-rtdb.firebaseio.com/adsdb/${localStorage.getItem("userEmail").replaceAll("@", "_").replaceAll(".", "_")}/${chatId}.json`, {
        method,
        headers:{
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body
    });
    return await response.json();
}

const CardView = function({id, type, click}) {
  if(type === "ai") {
    return   <div className="cursor-pointer" style={{width:"250px", height:"250px", float:"left", margin:"5px"}} onClick={click}>
    <iframe src={`https://api-fetch.mediadirhub.com/ads-banner/adsdb-html/${id}.html`} style={{width:"500px", height:"500px", float:"left", margin:"0", pointerEvents:"none", zoom:"0.5"}}></iframe>
</div>
  }
    return   <div className="cursor-pointer" style={{width:"250px", height:"250px", float:"left", margin:"5px"}} onClick={click}>
        <iframe src={`https://media.mediadirhub.com/add-banners/${id}.html`} style={{width:"500px", height:"500px", float:"left", margin:"0", pointerEvents:"none", zoom:"0.5"}}></iframe>
    </div>
    
//     <div className="max-w-sm bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700 float-left m-2">
//   <a href="#">
     
//     <img className="rounded-t-lg" src="https://flowbite.com/docs/images/blog/image-1.jpg" alt />
//   </a>
//   <div className="p-5 ">
//     <a href="#">
//       <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white hidden">Noteworthy technology acquisitions 2021</h5>
//     </a>
//     <p className="mb-3 font-normal text-gray-700 dark:text-gray-400 hidden">Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.</p>
//     <a href="#" className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
//       start with
//       <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
//         <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M1 5h12m0 0L9 1m4 4L9 9" />
//       </svg>
//     </a>
//   </div>
// </div>

    
}


export default function ChatWithImageUpload() {
  const [templates, setTemplates] = useState([]);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [image, setImage] = useState();
  const [id, setId] = useState(null);
  const [data, setData] = useState(null);
  const [chatId, setChatId] = useState(null);
  const [oldChats, setOldChats] = useState([]);
  const [popup, setPopup] = useState(false);
  const [email, setEmail] = useState(localStorage.getItem("userEmail")?localStorage.getItem("userEmail"):null);

  useEffect(() => {
    fetchOld();
    //Runs only on the first render
    fetch(`https://api-logs-app-default-rtdb.firebaseio.com/adsdb-html.json`).then(function(a){
      a.json().then(function(v){
        if(v) {
          setTemplates(Object.keys(v).map(function(k){
            console.log(k, v[k]);
              //v[k]["response"] = v[k]["data"];
              return {
                  id:k,
                  data:v[k].data
              }
            }));
          }
      })
    })
    
  }, []);

  const fetchOld = function() {
      if(localStorage.getItem("userEmail")) {
          try {
            fetch(`https://api-logs-app-default-rtdb.firebaseio.com/adsdb/${localStorage.getItem("userEmail").replaceAll("@", "_").replaceAll(".", "_")}.json`).then(function(a){
                a.json().then(function(v){
                if(v) {
                    setOldChats(Object.keys(v).map(function(k){
                        return {
                            id:k,
                            data:Object.keys(v[k]).map(function(ele){
                                const item = v[k][ele];
                                item.data = JSON.parse(item.data);
                                item.response = JSON.parse(item.response);
                                item["dbID"] = ele;
                                return item;
                            }) 
                        }
                      }));
                }
                  
                })
            })
          } catch (error) {
              
          }
        
      }
  }

  const fetchChat = async function(prompt, json) {

    let textPrompt = `
        Given the JSON structure below, update only the **values** (do not add, remove, or rename any keys or change the structure) according to the client prompt. Return only the updated JSON.

        Client prompt: "${prompt}"

        Original JSON:
        ${JSON.stringify(json, null, 2)}
    `
    if(image) {
        textPrompt = `
        change JSON data values as per client prompt, also used image url given below if client want change any image and return response JSON only as given.

        prompt:${prompt}

        image:${image}

        JSON:${JSON.stringify(json)}
        `
    }
    const response = await fetch(fetchURL, {
      method: "POST",
      body:JSON.stringify({
        "method":"fetchJSON",
        "text":textPrompt
      })
    });
  
    return await response.json();
  
}

  const postDB = async function(id, text, data, from) {
    const response = await fetchChat(text, data)
    const postJSON = {
        text:text,
        from:from,
        id:id,
        image:image,
        data:JSON.stringify(data),
        response:JSON.stringify(response)
    }
    const responseMe = await fetchDB(chatId, "POST", postJSON);
    postJSON["dbID"] = responseMe.name;
    setData(response);
    return postJSON;
  }

  const handleSend = () => {
    if (input || image) {
      preloader(true)
        postDB(id, input, data).then(function(message){
            console.log(message);
            setMessages([...messages, message]);
            //setMessages((prev) => [...prev, { text: 'This is a reply from AI.', from: 'bot' }]);
            setInput('');
            setImage(null);
            preloader(false)
        })
        
   
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
        
        // const canvas = document.createElement("canvas");
        // document.body.appendChild(canvas);

        // const ctx = canvas.getContext('2d');

        // const img = new Image();
        // const reader = new FileReader();
  
        // reader.onload = function(event) {
        //   img.onload = function() {
        //     canvas.width = img.width;
        //     canvas.height = img.height;
        //     ctx.drawImage(img, 0, 0);
            
        //     const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        //     const data = imageData.data;
  
        //     for (let i = 0; i < data.length; i += 4) {
        //       const r = data[i], g = data[i + 1], b = data[i + 2];
        //       if (r > 240 && g > 240 && b > 240) {
        //         data[i + 3] = 0; // Make pixel transparent
        //       }
        //     }
  
        //     ctx.putImageData(imageData, 0, 0);
        //   };

        //   fetch(event.target.result).then(function(blob){
           
        //   })
          

        //   //img.src = event.target.result;
        // };
  
        // reader.readAsDataURL(file);

        let formData = new FormData();
        formData.append('file', file);

        fetch("http://api-fetch.mediadirhub.com/uploadads-images", {
            method:"POST",
            body:formData
        }).then(function(a){
            a.json().then(function(ab){
                setImage(ab.image);
            })
        })

       
      //const imgURL = URL.createObjectURL(file);
      //setImage(imgURL);
    }
  };

  const clickMe = function(v) {
    console.log(v);
    setId(v.id);
    setData(v.data);
    setChatId(Date.now())
  }
    const clickSet = function(v) {
        setId(v.data[v.data.length-1].id);
        setData(v.data[v.data.length-1].response);
        setChatId(v.id);
        setMessages(JSON.parse(JSON.stringify(v.data)))
    }
  const joinEmail = function(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
        localStorage.setItem("userEmail", email);
        setEmail(email)     
    } 
    else {
        alert('Please enter valid email address!');
    }
  }
  if(popup) {
    return <ShowPopup close={() => setPopup(false)} callback={function(a){
        setOldChats([...oldChats, a]);
        setChatId(a.id);
        setId(a.data[0].id);
        setData(a.data[0].data);
       
        setTimeout(function(){
          setMessages(function(prevMessages){
            return [...messages, a.data[0]];
          })
          setPopup(false);
        }, 100)
    }} />
  }
  if(email === null) {
    return <JoinEmail joinEmail={joinEmail} />
  }
  
  if(id === null) {
    return <div className="cards p-4">

<div className="max-w-5xl mx-auto">




    <h2 className={`text-2xl font-bold mb-6 ${oldChats.length === 0?"hidden":""}`}>Old chats</h2>
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mb-4">
      {
          oldChats.map(function(v){
              return <div onClick={(e) => clickSet(v)} className="aspect-square overflow-hidden rounded-xl shadow-md bg-white cursor-pointer" >
              <img src="https://static.vecteezy.com/system/resources/thumbnails/004/141/669/small/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg" alt="Thumb 1" class="w-full h-full object-cover" onClick={() => function(){
                            
              }} />
            </div>
          })
      }
      
    </div>
  </div>


  <div class="max-w-5xl mx-auto clear-both mb-6">
       <h2 class="text-2xl font-bold mb-6">Create with using own sample and content!</h2>
       <div onClick={() => setPopup(true)}
  
  className="w-[200px] h-[200px] aspect-square overflow-hidden rounded-xl shadow-md bg-white cursor-pointer flex items-center justify-center text-center text-lg font-semibold hover:bg-gray-100 transition"
>
  Create New
</div>
      
           </div>
   


       <div class="max-w-5xl mx-auto clear-both mb-6">
       <h2 class="text-2xl font-bold mb-6">Select predefined templates to start!</h2>

       {
        allData.data.map(function(v){
            return <CardView id={v.id} click={() => clickMe(v)} />
        })
    }
           </div>

           <div class="max-w-5xl mx-auto clear-both mb-6">
       <h2 class="text-2xl font-bold mb-6">Select AI generated templates to start!</h2>

       {
        templates.map(function(v){
            return <CardView id={v.id} type="ai" click={() => clickMe(v)} />
        })
    }
           </div>          
    
    </div>
  }



  return (
    <div className="flex flex-col h-screen bg-gray-100 p-4">
      <div className="text-xl font-semibold mb-4">Chat</div>
      <div className="flex-1 overflow-y-auto space-y-4">
        {messages.map((msg, idx) => (
            <div className="clear-both margin-auto max-w-3xl" >
 <div class="flex flex-col items-end space-y-2">
      <div class="bg-blue-600 text-white p-3 rounded-xl shadow max-w-[75%]">
      {msg.text && <div>{msg.text}</div>}
      </div>
      {msg.image && (
              <img
                src={msg.image}
                
                alt="User image" className="rounded-xl shadow-md max-w-xs"
              />
            )}
    </div>



<div class="flex justify-start float-start p-2 m-2 bg-white rounded-xl">
<iframe src={`https://api-fetch.mediadirhub.com/ads-banner?id=${msg.id}&data=${msg.dbID}&chat=${chatId}&email=${email}`} style={{width:"500px", height:"500px", float:"left", margin:"0", pointerEvents:"none"}}></iframe>
    </div>


          
         
        </div>
        ))}
      </div>
      <div className="mt-4 flex items-center gap-2">
        <label className="cursor-pointer">
          <Plus className="w-6 h-6 text-blue-500" />
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            className="hidden"
          />
        </label>
        <input
          type="text"
          className="flex-1 p-2 border rounded"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type a message..."
        />
        <button
          onClick={handleSend}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Send
        </button>
      </div>
    </div>
  );
}

